export class WishList {
  constructor(public userId: string, public productId: string) {}
}
